import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    display: "flex",
    flexWrap: "wrap",
    gap: 8,
    columnGap: 16,
    '@media (max-width: 767px)': {
      columnGap: 8,
    }
  },
  item: {
    display: "flex",
    alignItems: "center",
    gap: 4,
  },
  label: {
    whiteSpace: "nowrap",
  },
}));
